import { useMutation, UseMutationResult } from "@tanstack/react-query";
import { CompanyRepositoryImpl } from "../../../data/repository/company_repository_impl";
import { AxiosError } from "axios";

export const useCheckCompanyExists = (): UseMutationResult<boolean, Error, string> => {
    const repository = new CompanyRepositoryImpl();

    return useMutation<boolean, AxiosError, string>({
        mutationFn: (pinValue) => repository.checkCompanyExists(pinValue),
        retry: 2,
    });
};